import BaseTemplate from '../../components/baseTemplate';
import LockedUser from './LockedUser';
import PasswordChange from './PasswordChange';
import PasswordSuccess from './PasswordSuccess';
import React, { useState } from 'react';
import './styles.scss';

const PasswordReset: React.FC = () => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [showLocked, setShowLocked] = useState(false);

    function willRender() {
        if (showSuccess) {
            return <PasswordSuccess />;
        } else if (showLocked) {
            return <LockedUser />;
        } else {
            return (
                <PasswordChange
                    setShowSuccess={setShowSuccess}
                    setShowLocked={setShowLocked}
                />
            );
        }
    }
    return <BaseTemplate>{willRender()}</BaseTemplate>;
};

export default PasswordReset;
